import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    backdrop: {
      zIndex: 1990,
      color: "#fff",
      backgroundColor: "rgba(0,0,0,0.6)",
    },
    container: {
      position: "fixed",
      top: "110px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 2000,
      backgroundColor: "rgba(255,255,255,0.95)",
      padding: "20px",
      paddingTop: "30px",
      paddingBottom: "12px",
      borderRadius: "12px",
      boxShadow: "0 0 20px rgba(245,0,87,0.5)",
      // minWidth: "400px",
      maxWidth: "90%",
      width: "500px",
      backdropFilter: "blur(10px)",
      animation: "popupFade 0.3s ease-out",
    },
    closeButton: {
      fontWeight: "bold",
      position: "absolute",
      right: -22,
      top: -33,
    },
    tempText: {
      position: "absolute",
      marginTop: "-25px",
      width: "100%",
      textAlign: "center",
      overflow: "hidden",
      color: "#f57f00",
      textShadow: "0 -3px 5px rgba(230,9,9,0.4)",
      direction: "rtl",
      whiteSpace: "nowrap",
    },
    micContainer: {
      position: "relative",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    footerContainer: {
      display: "flex",
      gap: 1,
      marginBottom: "8px",
      marginTop: "10px",
      justifyContent: "space-between",
      lineHeight: 2.4,
    },
    mapImage: {
      width: 20,
      height: 14,
      objectFit: "cover",
      marginRight: 8,
    },
    sugContainer: {
      position: "absolute",
      top: "40px",
      left: 0,
      right: 0,
      zIndex: 999,
      maxHeight: 200,
      overflowY: "auto",
    },
  })
);
